
import FormatCircle from "../../../assets/filled/FormatCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FormatCircleIcon({ className, dataTestid = "FormatCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FormatCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
